import { Heading, Image, Paragraph } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';

const MlsDisclaimer = ({ mls, i }) => {
    if (!mls.disclaimer) {
        return null;
    }

    return (
        <section id={`${mls.ssid}`}>
            <Heading
                level="2"
                fontType={{ default: 'h5', sm_lte: 'h6' }}
                marginBottom="sm"
            >
                {mls.longName}
            </Heading>
            {mls.logo && (
                <Image
                    src={`https://photos.zillowstatic.com/fp/${mls.logo}-full.png`}
                    width="70"
                    height="auto"
                    loading={i === 0 ? 'eager' : 'lazy'}
                    decoding={i === 0 ? 'sync' : 'async'}
                    marginBottom="sm"
                    alt={mls.longName}
                />
            )}
            <Paragraph fontType="finePrint" style={{ whiteSpace: 'pre-line' }}>
                {mls.disclaimer}
            </Paragraph>
        </section>
    );
};

MlsDisclaimer.propTypes = {
    mls: PropTypes.object.isRequired,
    i: PropTypes.number.isRequired,
};

export default MlsDisclaimer;
